export default __webpack_public_path__ + "static/media/floor_and_threshold.76c954db.svg";